import Html from './Html'

export default Html
